import React from "react";
import ComponenetHeader from "../common/ComponenetHeader";

const PrivacyPolicy = () => {

  return (<>

    {/*   <ComponenetHeader
      name={'Privacy Policy'}
    />  */}

    <section className="content_page text-left">
      <div className="container">
        <div className="row content_page_style justify-content-center">
          <div className="col-xl-12 col-lg-10 col-md-10">
            <h2 className="mb-4">Privacy Policy</h2>
            <h3>Introduction</h3>
            <p>At Truck Repair Shop, we are committed to protecting your privacy and ensuring that any personally identifiable information ("Personal Information") you provide is handled responsibly and securely.</p>
            <p>This Privacy Policy explains how we collect, use, and safeguard your Personal Information.</p>

            <h3>Personal Information</h3>
            <p>Personal Information refers to data that can identify an individual, such as names, addresses, email addresses, contact numbers, and any other information linked to a person.</p>
            <p>We may update this policy from time to time without prior notice. The most recent version will always be available on this website. By continuing to use our platform, you agree to follow the latest terms.</p>

            <h3>Cookies</h3>
            <p>"Cookies" are small files stored on your device by your web browser. They help us recognize returning users and personalize your experience, including offers and content.</p>
            <p>Most browsers accept cookies automatically, but you can modify your settings to block them. Keep in mind that disabling cookies may affect the optimal performance of our website.</p>

            <h3>How We Use Your Information</h3>
            <p>We use the information collected to:</p>
            <ul>
              <li>Create and manage your account.</li>
              <li>Enable secure login and authentication.</li>
              <li>Provide rewards for bill uploads and other app features.</li>
              <li>Send important updates, notifications, and offers.</li>
              <li>Enhance the performance and features of our app.</li>
              <li>Comply with applicable legal or regulatory requirements.</li>
            </ul>

            <h4>Rewards and Bill Uploads</h4>
            <p>When you upload bills through the app, we securely store these documents to verify your rewards. We do not use them for marketing purposes or share them with third parties. Participation in the rewards program is completely voluntary.</p>

            <h4>We do not sell your Personal Information or share it for marketing purposes.</h4>
            <p>Our platform collects information through:</p>
            <ul>
              <li>Usage of our website, mobile site, and app.</li>
              <li>Communication via email, SMS, or other electronic messages.</li>
              <li>Interactions with our social media channels such as Facebook, Twitter, LinkedIn, and YouTube.</li>
            </ul>
            <p>Third-party platforms may have their own privacy practices, and we are not responsible for them.</p>

            <h4>Disclosure of Your Personal Information</h4>
            <p>Truck Repair Shop may share your Personal Information:</p>
            <ul>
              <li>With third parties when you provide information through co-branded websites.</li>
              <li>With trusted partners assisting in business operations.</li>
              <li>During a business sale, merger, or transfer of assets.</li>
              <li>As required by law or legal proceedings.</li>
            </ul>
            <p>We do not sell or trade Personal Information. Company names of account holders or vendors may be shared, and vendor feedback may be shared with service providers only with consent.</p>

            <h4>Consent</h4>
            <p>By submitting your Personal Information, you consent to its collection, use, storage, and disclosure as outlined in this policy.</p>
            <p>We will inform users of major policy updates via email or website announcements. Please keep your contact information current and review this policy regularly.</p>

            <h4>Security Safeguards</h4>
            <p>Securing your data is a shared responsibility. Keep your account credentials safe and avoid posting sensitive information publicly.</p>
            <p>While we implement reasonable security measures, no method of internet transmission is entirely risk-free. Sharing information is done at your own risk.</p>

            <h5>Additional Information</h5>
            <p>If you have questions or concerns about this privacy policy, email us at <strong>contact@truckrepairshop.net</strong>.</p>

          </div>

        </div>
      </div>
    </section>

  </>
  );
};

export default PrivacyPolicy;